import React from 'react';
import { MdOutlineDateRange } from 'react-icons/md';
import { useRouter } from 'next/router';
import DataCounts from './dataCounts';
import dynamic from 'next/dynamic';
import { useDispatch, useSelector } from 'react-redux';
import CalendarPage from '../../CalendarItem/DashboardCalendar';
import CustomFlatpickr from 'components/Form/Picker/CustomFlatpickr';
import {
  getLiveClassesDateFilter,
  setLiveClassesDateFilter,
} from 'store/global';
import styles from 'styles/Header.module.scss';
import classnames from 'classnames';
import LiveClasses from '../../LiveClasses/liveClasses';
const LineChart = dynamic(() => import('./LineChart'), { ssr: false });
const DonutChart = dynamic(() => import('./donutChart'), { ssr: false });
const SparkLine = dynamic(() => import('./classesSparkLineChart'), {
  ssr: false,
});
//New Index Changes
const NewDashboardInstructor = () => {
  const dispatch = useDispatch();
  const liveClaasesDate = useSelector(getLiveClassesDateFilter);
  const getLiveClassesDate = (date) => {
    dispatch(setLiveClassesDateFilter(date));
  };
  const closeTime = (value) => {
    if (value?.length == 1) {
      dispatch(
        setLiveClassesDateFilter([
          new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000).setHours(
            0,
            0,
            0,
          ),
          new Date().setHours(0, 0, 0),
        ]),
      );
    }
  };
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-50">
        <h4 className="card-header-title-label mb-0">Dashboard</h4>
        <section className="date-range-card-dashboard-new d-flex mb-0">
          <span style={{ margin: '0px -5px 6px 10px', paddingTop: '4px' }}>
            <MdOutlineDateRange color="#8E96AA" size={25} />
          </span>
          <span style={{ marginTop: '3px' }}>
            <CustomFlatpickr
              time={liveClaasesDate}
              setTime={getLiveClassesDate}
              closeTime={closeTime}
            />
          </span>
        </section>
      </div>
      <div className="d-flex w-100 flex-wrap">
        <div className="col-md-8 px-0 d-flex flex-lg-row flex-column flex-wrap">
          <div
            className={`col-md-12 px-0 d-flex flex-lg-row flex-column flex-wrap`}
          >
            <DataCounts />
          </div>
          <div
            className={`col-md-12 px-0 d-flex flex-lg-row flex-column flex-wrap`}
          >
            <div className="col-md-6 pl-0 AdminCard_Charts">
              <LineChart />
            </div>

            <div className="col-md-6 pl-0 AdminCard_Charts">
              <DonutChart />
            </div>
          </div>
          <div
            className={`col-md-12 px-0 d-flex flex-lg-row flex-column flex-wrap`}
          >
            <div className="col pl-0">
              <SparkLine />
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <CalendarPage dayOrMonth="dayGridMonth" instructor="instructor" />
          <div className={classnames(styles['sparkCard'], 'mt-1')}>
            <LiveClasses />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewDashboardInstructor;
